import axios from 'axios';
import { getToken, getTokenCookie } from './auth';
import { applyRequestAuthorization } from './authHeader';
import { shouldTreatAsSessionExpiry } from './sessionExpiry';

let interceptorsRegistered = false;

export default function configureApiRestService() {
   axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
   axios.defaults.headers.common['Content-Type'] = 'application/json';
   axios.defaults.headers.common['Accept'] = 'application/json';
   if (interceptorsRegistered) {
      return;
   }
   interceptorsRegistered = true;

   axios.interceptors.request.use((config) => {
      const headers = config.headers ?? {};
      applyRequestAuthorization(headers, getToken(), getTokenCookie());
      config.headers = headers;
      return config;
   });

   axios.interceptors.response.use(function (response) {
      return response;
   }, function (error) {
      if (shouldTreatAsSessionExpiry(error.response?.status, error.config?.url)) {
         alert("Sesión caducada, por favor vuelva a ingresar");
         window.location.href = process.env.REACT_APP_BASE_URL as string;
      }
      return Promise.reject(error);
   });
}


